<template>
  <div class="training-camp">
    <MyHead />
    <van-tabs
      color="#ffffff"
      background="rgba(255, 255, 255, 0)"
      line-width="20px"
      title-active-color="#ffffff"
      title-inactive-color="rgba(255, 255, 255, 0.8)"
      swipeable
      sticky
      v-model="active"
    >
      <van-tab title="文案体系" v-for="(item, index) in 8" :key="index">
        <div class="tranining-camp-list">
          <CampCard v-for="(val, idx) in 8" :key="idx" />
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import { ref } from '@vue/composition-api';
import { Tab, Tabs } from 'vant';
import CampCard from '@/components/card/CampCard.vue';
import MyHead from './components/MyHead.vue';

export default {
  components: {
    MyHead,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    CampCard
  },
  setup() {
    const active = ref(0);

    return {
      active,
    };
  },
};
</script>

<style lang="stylus" scoped>
.training-camp {
  overflow-y: auto;
  height: 100vh;
  background-image: url('https://img01.yzcdn.cn/vant/cat.jpeg'); // img01.yzcdn.cn/vant/cat.jpeg)
  background-position: center center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: cover;
}

/deep/ .van-tab--active {
  font-size 18px
}

/deep/ .van-sticky--fixed {
  background-color #eee !important
}

/deep/ .van-sticky--fixed {
  .van-tab {
    color #999 !important
  }
}

/deep/ .van-sticky--fixed {
  .van-tab--active {
    color #191919 !important
  }
}

/deep/ .van-sticky--fixed {
  .van-tabs__line {
    background-color #FF9645 !important
  }
}

.tranining-camp-list {
  margin 12px
  padding 0 16px
  background #fff
  border-radius 8px
}
</style>
